import React, { Fragment, useState } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import ptLocale from "@fullcalendar/core/locales/pt"; // and another plugin!
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { ReactReduxContext } from "react-redux";
import Popover from "../UI/Popover/Popover";

const Calendar = (props) => {
	console.log("CALENDAR REFRESH")
	const [popoverVisible, setPopoverVisible] = useState(false);
	const [popoverInfo, setPopoverInfo] = useState({});

	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.calendarEvents; // StartDate=2021-01-01&EndDate=2021-08-31
	

	const sendClick = (info) => {
		console.log("ois")
		props.onEventClick(info)
	}

	const popoverCloseHandler = () => {
		setPopoverVisible(false);
	};

	return (
		<Fragment>
			<FullCalendar
				plugins={[dayGridPlugin]}
				initialView="dayGridMonth"
				locale={ptLocale}
				events={function (info, successCallback, failureCallback) {
					axios
						.get(
							url_data +
								"?StartDate=" +
								moment(info.start).format().split("T")[0] +
								"&EndDate=" +
								moment(info.end).format().split("T")[0],
							autenticationData
						)
						.then(function (response) {
							successCallback(response.data);
							// return response.data
						})
						.catch(function (error) {
							console.log("Show error notification!");
							failureCallback(error);
							// return Promise.reject(error)
						});
				}}
				eventClick={function (info) {
					info.jsEvent.preventDefault();
					// sendClick(info)
					setPopoverInfo(info);
					setPopoverVisible(true);
				}}
			/>
			{popoverVisible && (
				<Popover onClose={popoverCloseHandler}>
					<div style={{ padding: "14px 26px" }}>
						<b>{popoverInfo.event.title}</b>
					</div>
					<hr style={{ margin: 0, width: "100%" }} />
					<div style={{ padding: "14px 26px" }}>
						<p>
							<b>
								{moment(popoverInfo.event.start).format(
									"dddd"
								) +
									", " +
									moment(popoverInfo.event.start).format(
										"LL"
									)}
							</b>
						</p>
						<p>
							<b>
								Início{" "}
								{moment(popoverInfo.event.start).format("LT")}
							</b>
						</p>
						<p>
							<b>
								Fim {moment(popoverInfo.event.end).format("LT")}
							</b>
						</p>
						<p>
							Metedologia:{" "}
							<b>{popoverInfo.event.extendedProps.modality}</b>
						</p>
						<p>
							Formador:{" "}
							<b>{popoverInfo.event.extendedProps.instructor}</b>
						</p>
						<p>
							Sala: <b>{popoverInfo.event.extendedProps.sala}</b>
						</p>
					</div>
				</Popover>
			)}
		</Fragment>
	);
};

export default Calendar;
